import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Analytics } from '@vercel/analytics/react'
import App from './App.jsx'
import { SupportPage } from './components/SupportPage.jsx'
import { ComoFuncionaPage } from './components/pages/ComoFuncionaPage.jsx'
import { ParaQuemEPage } from './components/pages/ParaQuemEPage.jsx'
import { ResetPasswordPage } from './components/auth/ResetPasswordPage.jsx'
import { BlogListPage } from './components/pages/BlogListPage.jsx'
import { BlogPostPage } from './components/pages/BlogPostPage.jsx'
import { RecipesListPage } from './components/pages/RecipesListPage.jsx'
import { RecipeDetailPage } from './components/pages/RecipeDetailPage.jsx'
import { GoogleAnalytics } from './components/GoogleAnalytics.jsx'
import { AuthProvider } from './contexts/AuthContext'
import { validateEnvVars } from './utils/envValidation'
import './index.css'

// Valida variáveis de ambiente em desenvolvimento
validateEnvVars();

/**
 * Componente de roteamento simples
 * Detecta a rota atual e renderiza o componente apropriado
 */
const Router = () => {
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  
  // Páginas estáticas (SEO)
  if (path === '/apoie') return <SupportPage />;
  if (path === '/como-funciona') return <ComoFuncionaPage />;
  if (path === '/para-quem-e') return <ParaQuemEPage />;
  if (path === '/blog') return <BlogListPage />;
  if (path.startsWith('/blog/')) {
    const slug = path.slice('/blog/'.length).replace(/\/$/, '');
    if (slug) return <BlogPostPage slug={slug} />;
  }

  if (path === '/receitas') return <RecipesListPage />;
  if (path.startsWith('/receita/')) {
    const slug = path.replace(/^\/receita\/?/, '').replace(/\/$/, '');
    if (slug) return <AuthProvider><RecipeDetailPage slug={slug} /></AuthProvider>;
  }

  // Recuperação de senha (precisa do AuthProvider para Supabase processar o hash)
  if (path === '/redefinir-senha') {
    return (
      <AuthProvider>
        <ResetPasswordPage />
      </AuthProvider>
    );
  }
  
  // Rota padrão - app principal
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <GoogleAnalytics />
      <Router />
      <Analytics />
    </HelmetProvider>
  </React.StrictMode>,
)
